'use client';
import React from 'react';

interface AlertMessageProps {
  type: 'error' | 'success' | 'info';
  message: string;
}

export default function AlertMessage({ type, message }: AlertMessageProps) {
  if (!message) return null;

  const styles = {
    error: {
      container: 'bg-red-50 border-red-200',
      icon: 'bg-red-100 text-red-600',
      text: 'text-red-800',
    },
    success: {
      container: 'bg-emerald-50 border-emerald-200',
      icon: 'bg-emerald-100 text-emerald-600',
      text: 'text-emerald-800',
    },
    info: {
      container: 'bg-violet-50 border-violet-200',
      icon: 'bg-violet-100 text-violet-600',
      text: 'text-violet-800',
    },
  };

  const icons = {
    error: (
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    ),
    success: (
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    ),
    info: (
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
        clipRule="evenodd"
      />
    ),
  };

  const style = styles[type];

  return (
    <div className={`mb-6 border rounded-xl p-4 ${style.container}`}>
      <div className="flex items-start gap-3">
        <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${style.icon}`}>
          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            {icons[type]}
          </svg>
        </div>
        <p className={`text-sm ${style.text}`}>{message}</p>
      </div>
    </div>
  );
}
